module.exports = __webpack_public_path__ + "img/retailstore.dd59d066.jpg";